"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  PrMinBdDays: '薪酬福利管理',
  Basicdatasettings: '基础数据设定',
  serviceperiodstandardsetting: '服务期限标准设定',
  editserviceperiodstandardsetting: '编辑服务期限标准',
  PrMinBdDaysColumn: {
    no: '序号',
    stddesc: '标准名称',
    ownername: '船东',
    stdyear: '年月',
    currency: '币种',
    stdamt: '金额',
    stoped: '是否停用',
    startfrom: '开始日期',
    endwith: '结束日期',
    appstatus: '状态',
    remark: '备注',
    stdid: '配置',
    dutyname: '职务',
    jobclassname: '等级',
    stddays: '月数',
    stdyear2: '生效年月',
    timeoutsetting: '超时设置',
    authid: '工资编制',
    yes: '是',
    noo: '否',
    formt: '格式202205',
    approval: '审批',
    pending: '待审批',
    loggedout: '已注销',
    cmt: '是否提交',
    tosubmit: '已提交',
    nosubmit: '待提交'
  },
  PrMinBdDaystTips: {
    add: '新增',
    del: '删除',
    edit: '编辑',
    print: '输出',
    table: '表格',
    stamp: '打印',
    tips: '提示',
    save: '保存',
    submit: '提交',
    rollback: '退回',
    Select: '请选择',
    fullscreen: '全屏',
    reduction: '还原',
    close: '关闭',
    submitted: '已提交',
    unSubmitted: '未提交',
    ApproveInformation: '提交/审批信息',
    inputperson: '录入人',
    editor: '编辑人',
    SubmissionApprovalStatus: '提交/审批状态',
    commitstatus: '提交状态',
    creationtime: '创建时间',
    Changethetime: '修改时间',
    Submitter: '提交人',
    submissiontime: '提交时间',
    delSure: '请确认是否删除记录?',
    confirm: '确认',
    cancel: '取消',
    insert: '添加',
    delSuccess: '删除成功!',
    delFailed: '删除失败!',
    saveSuccess: '保存成功!',
    saveFailed: '保存失败!',
    selectOneData: '请选择至少一条数据',
    message1: '标准名称不能为空。请输入！',
    message2: '年月不能为空。请输入！',
    message3: '年月输入错误，年份应为6位整数，请重新输入！',
    message4: '工资编制不能为空。请输入！',
    message5: '船东不能为空。请输入！',
    message6: '金额不能为空。请输入！',
    message7: '月数不能为空。请输入！',
    message8: '开始日期不可晚于结束日期',
    message9: '不可删除已提交数据',
    message10: '请选择需要删除的行',
    message11: '职务为空，请输入！',
    message12: '等级为空，请输入！',
    message13: '系统可能不会保存您所做的更改',
    message14: '关闭窗口',
    message15: '至少添加一条明细',
    message16: '同职务的等级不可重复'
  }
};